import React, { useEffect, useState } from "react";
import { Box, Grid, Tooltip, Stack, Chip, Button, IconButton, Typography, useTheme, Divider, TextField, MenuItem, Paper } from "@mui/material";
import { Dialog, DialogTitle, DialogContent, DialogActions } from "@mui/material";
import { useLocalStorage } from "../../../hooks/useLocalStorage";

import { styled } from '@mui/material/styles';
import messages from "../messages";
import { FormattedMessage, useIntl } from "react-intl";
import { pushErrorMessage, pushNotification } from "../../../utils/notifications";
//Hooks
import { getAttachmentsForDrum } from "../../../hooks/attachment";

//Controls
import AxionControls from "../../../components/controls/AxionControls";
import AddAttachment from "./AddAttachment";
import Popup from "../../../components/controls/Popup";

//Icons
import LocationOnIcon from '@mui/icons-material/LocationOn';
import FormatLineSpacingIcon from '@mui/icons-material/FormatLineSpacing';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import CheckCircleOutlinedIcon from '@mui/icons-material/CheckCircleOutlined';
import PhotoIcon from '@mui/icons-material/Photo';
import DeleteIcon from '@mui/icons-material/Delete';
import SaveIcon from '@mui/icons-material/Save';

import { tokens } from "../../../assets/theme";
import { InfoOutlined } from "@mui/icons-material";
import { useQuery } from "@tanstack/react-query";
import DrumPhotoDialog from "./DrumPhotoDialog";
import { get } from "jquery";
import { use } from "react";

const DrumList = (props) => {
    const theme = useTheme();
    const colors = tokens(theme.palette.mode);
    const [drumQualities, setDrumQualities] = useState([]);
    const [manufacturerList, setManufacturerList] = useState([]);
    const [rejectedReasonsList, setRejectedReasonsList] = useState([]);
    const [articleList, setArticleList] = useState([]);
    const [newDrum, setNewDrum] = useState({ articleId: null, manufacturerId: null, itemCount: 0, qualityId: 0 });
    const [newCost, setNewCost] = useState({ articleId: null, manufacturerId: null, itemCount: 0, qualityId: 0, price: 0 });
    const [newCostValue, setNewCostValue] = useState(null);
    const [currentPhoto, setCurrentPhoto] = useState(null);

    const [openAttachments, toggleOpenAttachments] = React.useState(false);
    const [openPhotoPopup, setOpenPhotoPopup] = useState(false);
    const [photoForRowId, setPhotoForRowId] = useState(null);
    const [openMagnifyPopup, setOpenMagnifyPopup] = useState(false);
    const [magnifyAttachment, setMagnifyAttachment] = useState(null);
    const [trigger, setTrigger] = useState(false);
    const [allDelivered, setAllDelivered] = useState(false);
    const { formatMessage } = useIntl();
    const drumId = props.data
    const [instanceGermany, setInstanceGermany] = useLocalStorage("InstanceGermany", false);



    useEffect(() => {
        let quantetiesTranslations =
            [
                {
                    id: "str-drumquality-prime",
                    title: formatMessage(messages.drumList_drumqualityPrime),
                },
                {
                    id: "str-drumquality-fixable",
                    title: formatMessage(messages.drumList_drumqualityFixable),
                },
                {
                    id: "str-drumquality-rejected",
                    title: formatMessage(messages.drumList_drumqualityRejected),
                }
            ];

        let qualities = props.drumQualities.map((quality) => {
            return {
                id: quality.id,
                title: quantetiesTranslations.find(x => x.id === quality.description)?.title,
                quality: quality.drumquality1,
            };
        });
        setDrumQualities(qualities);
    }, [props.drumQualities]);

    useEffect(() => {
        let manufacturers = props.manufacturers.map((manufacturer) => {
            return {
                id: manufacturer.id,
                title: manufacturer.manufacturer1,
            };
        });
        setManufacturerList(manufacturers);
    }, [props.manufacturers]);

    useEffect(() => {
        let articles = props.articles.map((item) => {
            return {
                id: item.id,
                title: item.description,
                material: item.material,
                drumtype: item.drumtype,
                itemNo: item.itemNo,
                articleType: item.articleType,
            };
        });
        setArticleList(articles);
    }, [props.articles]);

    useEffect(() => {
        if (checkIfAllIsDelivered()) {
            setAllDelivered(true);
        }
    }, [props.data]);

    // useEffect(() => {
    //     console.log("Rejected reasons effect", props.rejectedReasons);
    //     let reasons = props.rejectedReasons.map((reason) => {
    //         return {
    //             id: reason.id,
    //             title: reason.reason,
    //         };
    //     });
    //     setRejectedReasonsList(reasons);
    // }, [props.rejectedReasons]);





    const newDrumChange = (event, field) => {
        switch (field) {
            case "newQualityId":
                setNewDrum({ ...newDrum, qualityId: event.target.value });
                break;
            case "newManufacturerId":
                setNewDrum({ ...newDrum, manufacturerId: event.target.value });
                break;
            case "newItemCount":
                setNewDrum({ ...newDrum, itemCount: event.target.value });
                break;
            case "newArticleId":
                setNewDrum({ ...newDrum, articleId: event.target.value });
                break;
            default:
                break;
        }
    }

    const newCostChange = (event, field) => {
        switch (field) {
            case "NewCostCostId":
                setNewCost({ ...newCost, price: event.target.value });
                break;
            case "newCostItemCountId":
                setNewCost({ ...newCost, itemCount: event.target.value });
                break;
            case "newCostArticleId":
                setNewCost({ ...newCost, articleId: event.target.value });
                setNewCostValue(props.articles.find(x => x.id === event.target.value).cashback);
                break;
            default:
                break;
        }
    }

    //Photo
    const handleCloseAttachmentsDialog = () => {
        toggleOpenAttachments(false);


        //console.log("cp_handle", props.data.find(x => x.id === currentPhoto).attachments);
        //console.log("cp_current photos", getAttachmentsForDrum(currentPhoto));

        //props.data.find(x => x.id === currentPhoto).attachments = getAttachmentsForDrum(currentPhoto);

        getAttachmentsForDrum(currentPhoto).then((result) => {
            //console.log("cp_handle", result);
            props.data.find(x => x.id === currentPhoto).attachments = result;
            setTrigger(!trigger);
        });


    };

    const handlePhotoIconClick = (event, index) => {
        setPhotoForRowId(index);
        setOpenPhotoPopup(true);
    }

    const handleAddItem = () => {
        props.handleAddRow(newDrum);

        setNewDrum({ articleId: null, manufacturerId: null, itemCount: 0, qualityId: 0 });
    }

    const handleAddCost = () => {
        props.handleAddRow(newCost);

        setNewDrum({ articleId: null, manufacturerId: null, itemCount: 0, qualityId: 0, price: 0 });
    }

    const handleShowMagnify = (attachment) => {
        setMagnifyAttachment(attachment);
        setOpenMagnifyPopup(true);
    }

    const handleCloseMagnify = () => {
        setOpenMagnifyPopup(false);
    }

    function getManufacturerName(id) {
        let manufacturer = props.manufacturers?.find(x => x.id === id);
        if (manufacturer === undefined) {
            return "Unknown";
        }
        return manufacturer.manufacturer1;
    }

    function getDrumCount(data) {
        //return data?.reduce((a, b) => parseInt(a) + parseInt((b['drumcount'] || 0)), 0);
        let filtered = data?.filter(x => x.article?.articleType !== 'FRA' && x.article?.articleType !== 'DES');
        return filtered?.filter(x => x.drumcount > 0).reduce((a, b) => parseInt(a) + parseInt((b['drumcount'] || 0)), 0);
    }

    function checkIfAllIsDelivered() {
        let result = true;
        props.data?.forEach((drum) => {
            //console.log ("drum", drum.drumcount, drum.locked);
            if (drum.drumcount > 0 && drum.locked !== 1) {
                result = false;
            }
        });
        return result;
    }

    function isOrderReady(status) {
        if (status === 9) {
            return true;
        }
        return false;
    }

    function checkIfAnyToDeliver() {
        let result = false;

        //console.log ("checkIfAnyToDeliver", allDelivered);
        if (checkIfAllIsDelivered()) {
            return false;
        }
        props.data?.forEach((drum) => {
            if (drum.drumcount > 0 && drum.locked !== 1) {
                //console.log ("checkIfAnyToDeliver...", isMarkable(drum));
                if (isMarkable(drum).isMarkable === true) {
                    result = true;
                }
            }
        });
        //console.log ("checkIfAnyToDeliver result",  result);
        return result;
    }


    function getCurrentDrums(material, drumtype, articleType) {

        if (articleType === 'SPL' && material === 'P') {
            let plastic = articleList.filter(x => x.material === material && x.drumtype === drumtype && x.articleType === 'SPL' && !x.itemNo.includes('-3')).map((item) => { return { id: item.id, title: item.itemNo + ' - ' + item.title } });
            return plastic || [];
        } else if (articleType === 'STL') {
            return articleList.filter(x => x.material === material && x.drumtype === drumtype && x.articleType === 'STL' && !x.itemNo.includes('-')).map((item) => { return { id: item.id, title: item.itemNo + ' - ' + item.title } });
        } else if ((articleType === 'EMB' || articleType === 'SPL' || articleType === 'SPR') && material === 'O') {
            return articleList.filter(x => x.material === material && (x.articleType === 'EMB' || x.articleType === 'SPL')).sort((a, b) => (a.title > b.title) ? 1 : -1).map((item) => { return { id: item.id, title: item.title } });  // && !x.itemNo.includes('-')
        } else if (articleType === 'AUS') {
            let articles = articleList.filter(x => x.articleType === 'AUS').map((item) => { return { id: item.id, title: item.title } });
            return articles.sort((a, b) => (a.title > b.title) ? 1 : -1) || [];
        } else if (articleType === 'KAB') {
            let articles = articleList.filter(x => x.articleType === 'KAB').map((item) => { return { id: item.id, title: item.title } });
            return articles.sort((a, b) => (a.title > b.title) ? 1 : -1) || [];
        } else {
            let articlesDefault = articleList.filter(x => x.articleType === 'COST').map((item) => { return { id: item.id, title: item.title } });
            return articlesDefault || [];
        }

        // switch (material) {
        //     case 'P':
        //         //console.log("PLASTIC");
        //         var plastic = articleList.filter(x => x.material === material && x.drumtype === drumtype && x.articleType === 'SPL' && !x.itemNo.includes('-3')).map((item) => { return { id: item.id, title: item.itemNo + ' - ' + item.title } });
        //         return plastic || [];
        //     case 'W':
        //         //console.log("WOOD");
        //         return articleList.filter(x => x.material === material && x.drumtype === drumtype && x.articleType === 'STL' && !x.itemNo.includes('-')).map((item) => { return { id: item.id, title: item.itemNo + ' - ' + item.title } });
        //     case 'O':
        //         //console.log("OTHER");
        //         return articleList.filter(x => x.material === material && x.drumtype === drumtype && (x.articleType === 'EMB' || x.articleType == 'SPL') && !x.itemNo.includes('-')).map((item) => { return { id: item.id, title: item.title } });
        //     case 'A':
        //         let articles = articleList.filter(x => x.material === material && x.articleType === 'AUS').map((item) => { return { id: item.id, title: item.title } });
        //         return articles || [];
        //     default:
        //         //console.log("OTHER");
        //         let articlesDefault = articleList.filter(x => x.articleType === 'COST').map((item) => { return { id: item.id, title: item.title } });
        //         return articlesDefault || [];
        // }
    }

    function getAllDrums() {
        var articles = [...articleList];
        articles.sort((a, b) => (a.locked < b.locked) ? 1 : -1);
        articles.sort((a, b) => (a.drumtype < b.drumtype) ? 1 : -1);
        articles.sort((a, b) => (a.material > b.material) ? 1 : -1);
        if (instanceGermany) {
            articles.sort((a, b) => (a.sortPrio > b.sortPrio) ? 1 : -1);
            articles = articles.filter(x => !(x.itemNo.includes('-3') || x.itemNo.includes('-2'))).map((item, index) => { return { id: item.id, title: item.title, sortorder: index } });
        } else {
            articles = articles.filter(x => x.material === 'P' || x.material === 'W' || x.material === 'O');
            articles = articles.filter(x => !(x.itemNo.includes('-3') || x.itemNo.includes('-2'))).map((item, index) => { return { id: item.id, title: item.material + ' - ' + item.drumtype + ' - ' + item.itemNo + ' - ' + item.title, sortorder: index } });
        }

        return articles || [];
    }

    function getAllCosts() {
        var articles = [...articleList];
        //Remove all that are in  props?.data
        let currentArticles = props.data?.map((item) => { return item.article?.id });
        let CASet = new Set(currentArticles);
        articles = articles.filter(x => !CASet.has(x.id));
        articles = articles.filter(x => x.articleType === 'FRA' || x.articleType === 'DES').sort((a, b) => (a.title > b.title) ? 1 : -1).map((item, index) => { return { id: item.id, title: item.title, sortorder: index } });
        //articles.sort((a, b) => (a.description < b.description) ? 1 : -1);
        //articles.sort((a, b) => (a.material > b.material) ? 1 : -1);
        //articles = articles.filter(x => !(x.itemNo.includes('-3') || x.itemNo.includes('-2'))).map((item, index) => { return { id: item.id, title: item.material + ' - ' + item.drumtype + ' - ' + item.itemNo + ' - ' + item.title, sortorder: index } });
        return articles || [];
    }

    function getDrumQualitiesByMaterial(material) {
        switch (material) {
            case 'P':
                return drumQualities.filter(x => x.id !== 2);
            case 'W':
                return drumQualities;
            case 'O':
                return drumQualities.filter(x => x.id !== 2);
            case 'A':
                return drumQualities.filter(x => x.id !== 2);
            default:
                return drumQualities.filter(x => x.id !== 2);
        }
    }

    function isPhotoNeeded(drum) {
        if (drum.article?.material === 'P' || drum.article?.material === 'W') {
            if (drum.drumqualityid > 1 && drum.attachments?.length < 1) { return true; }
        }
        return false
    }

    function isCostArticle(itemType) {
        if (itemType === 'FRA' || itemType === 'DES') {
            return true;
        }
        return false;
    }

    function isNonDrumArticle(articleType, material) {
        if (articleType === 'AUS' ) {
            return true;
        }
        if (articleType === 'KAB' ) {
            return true;
        }
        if ((articleType === 'EMB' || articleType === 'SPR') && material === 'O') {
            return true;
        }
        return false;
    }


    function isMarkable(drum) {

        var message = "";

        //console.log ("isMarkable", drum);

        //Plastic
        if (drum.article?.material === 'P' && drum?.article?.articleType === 'SPL') { // && (drum.id === null || (drum.article?.visibleForSupplier === true && drum.drumqualityid === null))) {
            if (drum.id === null) { message = message + "Order must be saved before marking the article as delivered. "; }
            //###
            if (drum.article?.visibleForSupplier === true && drum.drumqualityid === 1 && !instanceGermany) { message = message + "A specific drum must be selected before marking the article as delivered. "; }
            if (drum.drumqualityid === null || drum.drumqualityid === 0) { message = message + "Drum quality must be selected before marking the article as delivered. "; }
            // if (drum.drumqualityid > 1 && drum.attachments?.length < 1) { message = message + "Photos must be added for selected quality. "; }
            if (message !== "") {
                return { isMarkable: false, message: message };
            }
        }
        //Wood
        if (drum.article?.material === 'W' && drum?.article?.articleType === 'STL') {// && (drum.id === null || drum.drumqualityid === null)) {
            if (drum.id === null) { message = message + "Order must be saved before marking the article as delivered. "; }
            if (drum.drumqualityid === null || drum.drumqualityid === 0) { message = message + "Drum quality must be selected before marking the article as delivered. "; }
            // if (drum.drumqualityid > 1 && drum.attachments?.length < 1) { message = message + "Photos must be added for selected quality. "; }
            if (message !== "") {
                return { isMarkable: false, message: message };
            }
        }
        //Other
        if (drum.article?.material === 'O') {  // && (drum.id === null || drum.drumqualityid === null)
            if (drum.id === null) { message = message + "Order must be saved before marking the article as delivered. "; }
            // message = "NOT IMPLEMENTED!!! ...Drum quality must be set before marking as delivered";

            if (message !== "") {
                return { isMarkable: false, message: message };
            }
        }
        message = "Click to mark drum as delivered";
        return { isMarkable: true, message: message };
    }

    const DemoPaper = styled(Paper)(({ theme }) => ({
        //width: 120,
        //height: 120,
        backgroundColor: colors.primary[400],
        //paddingTop: theme.spacing(2),
        //...theme.typography.body2,
        textAlign: 'center',
    }));


    function getResultingArticleId(drum) {
        let articleId = drum.articleId;

        let newArticle = null;

        if (drum.drumqualityid === 1) {
            newArticle = articleList?.find(x => x.id.toString() === drum.article?.primeArticle);
        }
        else if (drum.drumqualityid === 2) {
            newArticle = articleList?.find(x => x.id.toString() === drum.article?.fixableArticle);
        }
        else if (drum.drumqualityid === 3) {
            newArticle = articleList?.find(x => x.id.toString() === drum.article?.rejectedArticle);
        } else {
            newArticle = drum.article;
        }

        return newArticle?.itemNo;
    }

    function getReadableFileName(fileName) {
        if (fileName === null || fileName === undefined) {
            return "";
        }
        return fileName.slice(fileName.indexOf('_') + 1)
    }

    if (props.data === null) {
        return <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}><img width="50px" height="50px" src="../../../assets/axion_spinner_white.gif" alt="Waiting for data to load..."></img></div>;
    }

    let data = {};//props.data?.sort((a, b) => (a.article?.drumtype < b.article?.drumtype) ? 1 : -1).sort((a, b) => (a.article?.material > b.article?.material) ? 1 : -1);
    data = props.data;

    let reasons = props.rejectedReasons?.map((reason) => {
        return {
            id: reason.id,
            title: reason.reason,
        };
    });

    // Update markable status for each drum
    data.forEach((item, index) => {
        item.markableStatus = isMarkable(item);
    });


    // console.log("Articles", articleList);
    // console.log ("newCost", newCost);
    console.log("zzzDrums", props?.data);
    //console.log("zzznewDrum", newDrum);
    //console.log("filtered", articleList.filter(x => x.material === 'P').map((item) => { return { id: item.id, title: item.title } }))

    //console.log("zzzcost", newCost);
    // console.log("AllDelivered", allDelivered);

    let content = <>
        <Box color={colors.primary[100]} >
            <Grid container alignItems="center" width="100%" height="" direction="row" spacing="1px" padding="10px">
                <Grid item xs={12}>
                    <Stack direction="row" display="flex" justifyContent="flex-start" alignItems="flex-end" spacing="10px" paddingTop="0px" paddingBottom="10px">

                        <Box width="700px"><Typography><FormattedMessage {...messages.drumList_totalNumberOfDrums} />: {getDrumCount(props.data)}</Typography></Box>
                        <Box width="250px" display="flex" justifyContent="flex-start">
                            {/* Deliver */}
                            <Button
                                sx={{
                                    width: "120px",
                                    backgroundColor: colors.dashbordGreen[500],
                                    "&:hover": {
                                        backgroundColor: colors.dashbordGreen[400],
                                        borderColor: "#5e7939",
                                        boxShadow: "none",
                                    },
                                    marginRight: "0px",
                                    // marginBottom: "15px",
                                }}
                                disabled={!checkIfAnyToDeliver()}
                                onClick={() => props.handleDeliverReadyRows()}
                            ><CheckCircleOutlinedIcon fontSize="small" />&nbsp;<FormattedMessage {...messages.drumList_btnDeliver} /></Button>
                            {/* Close order */}
                            <Button
                                sx={{
                                    marginLeft: "10px",
                                    width: "120px",
                                    backgroundColor: colors.dashbordGreen[500],
                                    "&:hover": {
                                        backgroundColor: colors.dashbordGreen[400],
                                        borderColor: "#5e7939",
                                        boxShadow: "none",
                                    },
                                    marginRight: "0px",
                                    // marginBottom: "15px",
                                }}
                                disabled={!checkIfAllIsDelivered() || isOrderReady(props.status)}
                                onClick={() => props.handleCloseOrder()}
                            ><CheckCircleOutlinedIcon fontSize="small" />&nbsp;<FormattedMessage {...messages.drumList_btnCloseOrder} /></Button>
                        </Box>
                    </Stack>
                </Grid>
                <Grid item xs={12} marginBottom="5px"><Divider color={colors.primary[900]} /></Grid>
                {data?.sort((a, b) => (a.article?.description > b.article?.description) ? 1 : -1)
                    .sort((a, b) => (a.article?.drumtype < b.article?.drumtype) ? 1 : -1)
                    .sort((a, b) => (a.article?.material > b.article?.material) ? 1 : -1)
                    .sort((a, b) => (a.markableStatus?.isMarkable < b.markableStatus?.isMarkable) ? 1 : -1)
                    .sort((a, b) => (a.locked > b.locked) ? 1 : -1)
                    .map((drum, index) => {
                        return (<>
                            {(drum?.drumcount > 0 || drum?.drumcount === null) &&
                                <>
                                    <Grid item xs={12} marginTop="5px" marginBottom="5px" boxShadow={1}>
                                        {/* <DemoPaper square={false} key={"demo_" + drum?.rowKey}> */}
                                        {/* boxShadow={1} */}
                                        <Stack direction="row" display="flex" justifyContent="flex-start" spacing="20px" paddingTop="10px" paddingBottom="10px">

                                            {(isCostArticle(drum?.article?.articleType)) ?
                                                <Box width="40px"></Box>
                                                :
                                                (drum?.drumcount > 1 && drum.locked !== 1) ?
                                                    <IconButton width="40px"><FormatLineSpacingIcon fontSize="medium" onClick={() => props.splitRow(index)} /></IconButton>
                                                    :
                                                    <IconButton width="40px" disabled={true}><FormatLineSpacingIcon fontSize="medium" /></IconButton>
                                            }
                                            {/* <AxionControls.AxionSelect id="reeltypeid" label={formatMessage(messages.typeOfDrum)} value={drum?.reeltypeid} options={reeltypesList} sx={{ width: '120px' }} onChange={(event) => props.handleRowChange(index, event, "reeltypeid")} /> */}

                                            {drum?.articleId === null ?
                                                <Box display="flex" justifyContent="flex-start" alignItems="center" height="46px" width="100px">{drum?.reeltype?.reeltype1}</Box>
                                                :
                                                (isCostArticle(drum?.article?.articleType) || drum.locked === 1) ?
                                                    <Box display="flex" justifyContent="flex-start" alignItems="center" height="46px" width="320px">{drum?.article?.description}</Box>
                                                    :
                                                    <AxionControls.AxionSelect id="reeltypeid" label={formatMessage(messages.drumList_typeOfDrum)} value={drum?.article.primeArticle || ''} options={getCurrentDrums(drum?.article?.material, drum?.article?.drumtype, drum?.article?.articleType)} sx={{ width: '320px' }} onChange={(event) => props.handleRowChange(index, event, "reeltypeid")} />
                                                       
                                            }
                                            {/* {drum.drumqualityid === null ?
                                                <AxionControls.AxionSelect id="reeltypeid" label={formatMessage(messages.typeOfDrum)} value={drum?.articleId} options={getCurrentDrums(drum?.article?.material, drum?.article?.drumtype, drum?.article?.itemNo)} sx={{ width: '320px' }} onChange={(event) => props.handleRowChange(index, event, "reeltypeid")} />
                                                :
                                                <Box>{drum?.article?.itemNo + " - " + drum?.article?.drumtype + " - " + drum?.article?.description}</Box>
                                            } */}
                                            {/* {drum?.article?.material !== 'P' ?
                                                <AxionControls.AxionSelect id="manufacturerid" label={formatMessage(messages.manufacturer)} value={drum?.manufacturerid || ''} options={manufacturerList} sx={{ width: '240px' }} onChange={(event) => props.handleRowChange(index, event, "manufacturerid")} />
                                                :
                                                <Box sx={{ width: '240px' }}></Box>
                                            } */}
                                            {drum.locked === 1 ?
                                                <Box display="flex" justifyContent="flex-start" alignItems="center" height="46px" width="70px" paddingLeft="8px">{drum?.drumcount}</Box>
                                                :
                                                <AxionControls.AxionTextBox id="drumcount" key={"count_" + drum?.rowKey} label={formatMessage(messages.drumList_nrOfItems)} value={drum?.drumcount} sx={{ width: '70px' }} onChange={(event) => props.handleRowChange(index, event, "drumcount")} />
                                            }
                                            {isCostArticle(drum?.article?.articleType) || isNonDrumArticle(drum?.article?.articleType, drum?.article?.material) ?
                                                <Box width="240px"></Box>
                                                :
                                                <AxionControls.AxionSelect id="drumqualityid" label={formatMessage(messages.drumList_quality)} value={drum?.drumqualityid || ''} options={getDrumQualitiesByMaterial(drum?.article?.material)} sx={{ width: '240px' }} onChange={(event) => props.handleRowChange(index, event, "drumqualityid")} />
                                            }



                                            <Stack direction="row" width="150px" display="flex" alignContent="flex-end" alignItems="center" justifyContent="flex-start" spacing="auto">

                                                {drum.locked === 1 ?
                                                    <IconButton><CheckCircleIcon fontSize="medium" sx={{ color: colors.dashbordGreen[500] }} /></IconButton>
                                                    :
                                                    drum.markableStatus?.isMarkable ?
                                                        <Tooltip title={<Typography fontSize="12px">{drum.markableStatus?.message}</Typography>}><IconButton onClick={(event) => props.handleDeliverRow(index, event)} ><CheckCircleOutlinedIcon fontSize="medium" sx={{ color: colors.dashbordGreen[500] }} /></IconButton></Tooltip>
                                                        :
                                                        <Tooltip title={<Typography fontSize="12px">{drum.markableStatus?.message}</Typography>}><IconButton ><CheckCircleOutlinedIcon fontSize="medium" /></IconButton></Tooltip>
                                                }

                                                <IconButton onClick={() => { setCurrentPhoto(drum.id); toggleOpenAttachments(true) }}><PhotoIcon fontSize="medium" sx={{ color: isPhotoNeeded(drum) ? colors.redAccent[500] : drum.attachments?.length > 0 ? colors.dashbordGreen[500] : '' }} />{ }</IconButton>

                                                {/* <IconButton><PhotoIcon fontSize="medium" onClick={(event) => handlePhotoIconClick(event, index)} />2</IconButton> */}


                                                {drum.locked === 1 ?
                                                    <DeleteIcon fontSize="medium" sx={{ color: colors.gray[500] }} />
                                                    :
                                                    <IconButton onClick={(event) => props.handleDeleteRow(index, event)}><DeleteIcon fontSize="medium" sx={{ color: colors.redAccent[500] }} /></IconButton>
                                                }
                                                <Tooltip title={<Typography fontSize="12px">Resulting article: {getResultingArticleId(drum)}</Typography>}><InfoOutlined sx={{ color: colors.gray[500] }}></InfoOutlined></Tooltip>

                                            </Stack>

                                        </Stack>

                                        <Stack direction="row" display="flex" justifyContent="flex-start" spacing="10px" paddingTop="0px" paddingBottom="10px" paddingLeft="55px">
                                            {(drum.drumqualityid === 3 && !instanceGermany) &&
                                                <>
                                                    <AxionControls.AxionSelect id="rejectedReasonId" label={"Anledning till avvisning"} options={reasons} value={drum?.rejectedReasonId || ''} sx={{ width: '320px' }} onChange={(event) => props.handleRowChange(index, event, "rejectedReasonId")} />
                                                    <Box width="1px"></Box>
                                                </>
                                            }
                                            {drum.attachments?.map((attachment, index) => {

                                                let url = "/api/attachments/" + attachment.id;
                                                return (
                                                    <Box height="54px" width="54px" backgroundColor={colors.primary[900]} justifyContent="center" alignItems="center" display="flex" onClick={() => handleShowMagnify(attachment)} >
                                                        <Tooltip title={<Typography fontSize="12px">{getReadableFileName(attachment.fileName)}</Typography>}>
                                                            <img
                                                                // src={isImageType(a.fileType) ? a.fileName : getDocIcon(a.fileName)}
                                                                src={url}
                                                                alt={`Attached document`}
                                                                // height="40px"
                                                                style={{ maxWidth: "50px", maxHeight: "50px", display: "block" }}
                                                            />
                                                        </Tooltip>
                                                    </Box>
                                                )
                                            })}
                                        </Stack>
                                        {/* </DemoPaper> */}
                                    </Grid>
                                </>}
                            {/* <Grid item xs={12}><Divider color={colors.primary[900]} /></Grid>     */}
                        </>)
                    })}

                <Grid item xs={12} marginTop="25px"><Typography><FormattedMessage {...messages.drumList_lblAddItem} /></Typography></Grid>
                <Grid item xs={12} marginBottom="5px"><Divider color={colors.primary[900]} /></Grid>
                <Grid item xs={12} marginTop="5px" marginBottom="5px" >
                    {/* <DemoPaper square={false}> */}
                    {/* boxShadow={1} */}
                    <Stack direction="row" display="flex" alignContent="center" alignItems="center" spacing="20px" paddingTop="10px" paddingBottom="10px" boxShadow={1}>
                        <Box width="40px"> </Box>
                        <AxionControls.AxionSelect id="newArticleId" label={formatMessage(messages.drumList_typeOfDrum)} value={newDrum.articleId || ''} options={getAllDrums()} sx={{ width: '320px' }} onChange={(event) => newDrumChange(event, "newArticleId")} />
                        {/* <AxionControls.AxionTextBox id="newArticleId" label={"Type of drum"} sx={{ width: '70px' }}
                                value={newDrum.articleId}
                                onChange={(event) => newDrumChange(event, "newArticleId")} /> */}
                        {/* <AxionControls.AxionTextBox id="newManufacturerId" label={"Manufacturer"} sx={{ width: '240px' }}
                                value={newDrum.manufacturerId}
                                onChange={(event) => newDrumChange(event, "newManufacturerId")} /> */}
                        <AxionControls.AxionTextBox id="newItemCount" label={"Antal"} sx={{ width: '70px' }}
                            value={newDrum.itemCount}
                            onChange={(event) => newDrumChange(event, "newItemCount")} />
                        <TextField
                            id="newQualityId"
                            select
                            label="Quality"
                            //defaultValue="0"
                            variant="standard"
                            value={newDrum.qualityId || ''}
                            onChange={(event) => newDrumChange(event, "newQualityId")}
                            inputProps={{ sx: { backgroundColor: '#fff', padding: '5px', width: '210px' } }}
                        >
                            {/* {currencies.map((option) => ( */}
                            <MenuItem key={0} value={0}>
                                {" "}
                            </MenuItem>
                            <MenuItem key={1} value={1}>
                                {"Prime"}
                            </MenuItem>
                            <MenuItem key={2} value={2}>
                                {"Repairable"}
                            </MenuItem>
                            <MenuItem key={3} value={3}>
                                {"Rejected"}
                            </MenuItem>
                            {/* ))} */}
                        </TextField>
                        <Box width="200px" display="flex" justifyContent="flex-start">
                            <Button
                                sx={{
                                    width: "90px",
                                    backgroundColor: colors.dashbordGreen[500],
                                    "&:hover": {
                                        backgroundColor: colors.dashbordGreen[400],
                                        borderColor: "#5e7939",
                                        boxShadow: "none",
                                    },
                                    marginRight: "15px",
                                    // marginBottom: "15px",
                                }}
                                disabled={allDelivered}
                                onClick={() => handleAddItem(newDrum)}
                            ><FormattedMessage {...messages.drumList_btnAddItem} /></Button>
                        </Box>
                    </Stack>
                    {/* </DemoPaper> */}
                </Grid>


                {/* Add Cost */}
                {!instanceGermany &&
                    <>
                        <Grid item xs={12} marginTop="25px"><Typography><FormattedMessage {...messages.drumList_lblAddCost} /></Typography></Grid>
                        <Grid item xs={12} marginBottom="5px"><Divider color={colors.primary[900]} /></Grid>
                        <Grid item xs={12} marginTop="5px" marginBottom="5px" >
                            <Stack direction="row" display="flex" alignContent="center" alignItems="center" spacing="20px" paddingTop="10px" paddingBottom="10px" boxShadow={1}>
                                <Box width="40px"> </Box>
                                <AxionControls.AxionSelect id="newCostArticleId" label={formatMessage(messages.drumList_typeOfDrum)} value={newCost.articleId || ''} options={getAllCosts()} sx={{ width: '320px' }} onChange={(event) => newCostChange(event, "newCostArticleId")} />
                                <AxionControls.AxionTextBox id="newCostItemCountId" label={"Antal"} sx={{ width: '70px' }}
                                    value={newCost.itemCount}
                                    onChange={(event) => newCostChange(event, "newCostItemCountId")} />
                                <Box width="239px" display="flex" justifyContent="flex-start" alignItems="flex-end" height="46px" paddingBottom="3px" >
                                    {Math.abs(newCostValue || 0).toFixed(0)} kr
                                </Box>
                                <Box width="100px" >
                                    <Button
                                        sx={{
                                            width: "90px",
                                            backgroundColor: colors.dashbordGreen[500],
                                            "&:hover": {
                                                backgroundColor: colors.dashbordGreen[400],
                                                borderColor: "#5e7939",

                                                boxShadow: "none",
                                            },
                                            marginRight: "15px",
                                            // marginBottom: "15px",
                                        }}
                                        disabled={allDelivered}
                                        onClick={() => handleAddCost(newCost)}
                                    ><FormattedMessage {...messages.drumList_btnAddCost} /></Button>
                                </Box>
                            </Stack>
                        </Grid>
                    </>
                }
            </Grid>
        </Box>
        <Dialog open={openAttachments} maxWidth="md" >
            <Box m={0} sx={{ backgroundColor: colors.primary[400], borderRadius: "4px" }} width="500px" >

                <DialogTitle><FormattedMessage {...messages.drumList_add_delete_attachments} /> </DialogTitle>
                <DialogContent>
                    <AddAttachment drumId={currentPhoto} />
                    {/* <DrumPhotoDialog drumId={currentPhoto} data={props.data[photoForRowId]}  /> */}
                </DialogContent>
                <DialogActions>
                    {/* <Button onClick={handleCloseAttachmentsDialog}
                                    sx={{
                                        "&:hover": {
                                            backgroundColor: "#535560",
                                        },
                                        backgroundColor: colors.primary[300],
                                        color: "#000000",
                                        marginBottom: "15px",
                                    }}><FormattedMessage {...messages.attachmentDialogClose} /></Button> */}
                    <Button
                        sx={{
                            backgroundColor: colors.dashbordGreen[500],
                            "&:hover": {
                                backgroundColor: colors.dashbordGreen[400],
                                borderColor: "#5e7939",
                                boxShadow: "none",
                            },
                            marginRight: "15px",
                            // marginBottom: "15px",
                        }}
                        onClick={handleCloseAttachmentsDialog}
                    ><FormattedMessage {...messages.drumList_attachmentDialogClose} /></Button>
                </DialogActions>
            </Box>
        </Dialog>
        <Popup
            openPopup={openPhotoPopup}
            setOpenPopup={setOpenPhotoPopup}
            title={<FormattedMessage {...messages.drumList_photoPopupTitle} />}>
            <DrumPhotoDialog
                data={props.data[photoForRowId]}
            />
        </Popup>
        <Dialog open={openMagnifyPopup} onClose={handleCloseMagnify} maxWidth="md" >
            <DialogTitle><FormattedMessage {...messages.drumList_photoPopupTitle} /> </DialogTitle>
            <DialogContent>
                <Box height="600px" width="800px" backgroundColor={colors.primary[900]} justifyContent="center" alignItems="center" display="flex" >
                    <Tooltip title={<Typography fontSize="12px">{getReadableFileName(magnifyAttachment?.fileName)}</Typography>}>
                        <img
                            // src={isImageType(a.fileType) ? a.fileName : getDocIcon(a.fileName)}
                            src={"/api/attachments/" + magnifyAttachment?.id}
                            alt={`Attached document`}
                            // height="40px"
                            //style={{ maxWidth: "500px", maxHeight: "700px", display: "block" }}
                            style={{ maxWidth: "100%", maxHeight: "100%", display: "block" }}
                        />
                    </Tooltip>
                </Box>
            </DialogContent>
            <DialogActions>
                {/* <Button onClick={handleCloseAttachmentsDialog}
                                    sx={{
                                        "&:hover": {
                                            backgroundColor: "#535560",
                                        },
                                        backgroundColor: colors.primary[300],
                                        color: "#000000",
                                        marginBottom: "15px",
                                    }}><FormattedMessage {...messages.attachmentDialogClose} /></Button> */}
                <Button
                    sx={{
                        backgroundColor: colors.dashbordGreen[500],
                        "&:hover": {
                            backgroundColor: colors.dashbordGreen[400],
                            borderColor: "#5e7939",
                            boxShadow: "none",
                        },
                        marginRight: "15px",
                        // marginBottom: "15px",
                    }}
                    onClick={handleCloseMagnify}
                ><FormattedMessage {...messages.drumList_attachmentDialogClose} /></Button>
            </DialogActions>
        </Dialog>
        {/* <Popup
            openPopup={openMagnifyPopup}
            setOpenPopup={setOpenMagnifyPopup}

            title={<FormattedMessage {...messages.photoPopupTitle} />}>

            <Box height="520px" width="720px" backgroundColor={colors.primary[900]} justifyContent="center" alignItems="center" display="flex" >
                <Tooltip title={<Typography fontSize="12px">{getReadableFileName(magnifyAttachment?.fileName)}</Typography>}>
                    <img
                        // src={isImageType(a.fileType) ? a.fileName : getDocIcon(a.fileName)}
                        src={"/api/attachments/" + magnifyAttachment?.id}
                        alt={`Attached document`}
                        // height="40px"
                        style={{ maxWidth: "500px", maxHeight: "700px", display: "block" }}
                    />
                </Tooltip>
            </Box>

        </Popup> */}

    </>;

    return (
        <>
            {content}

        </>
    )
};

export default DrumList;
